import React from 'react';	
import CorePage from './CorePage';
import FnFImg from '../../images/bg-404.png';
import '../../css/errorPage.css';

export default class ErrorPage extends CorePage{
	
	componentDidMount(){
			
		try{
			var errPath = document.location.pathname;	
			if(errPath !== null && errPath.length > 1){
				errPath = errPath.replace("/","");
				document.title +=  " " + errPath + " ";
			}else{
				document.title += " 404 ";
			}
		}catch(e){
			document.title += " 404 ";
		}
		
		
	}

	render(){
		return(
			<div className="errorContainer">
				<div className="errorback text-center">
						<div className="fff">
							<div>
								<div > <span className="f100 robotto fwb" >404</span></div><br/>
								<div ><span className="f40 fwb">Oops.</span></div><br/>
								<div ><span className="f30">You seem to be lost.</span></div><br/>
								<div className="f30"><span>Let&#39;s get you back <a href="/" className="r-btn errHome">Home</a> </span></div>
							</div>
					</div>
				</div>
			</div>

		);
	}
}


// WEBPACK FOOTER //
// ./src/views/core/ErrorPage.js